<div class="hd-icon hd-icon-screencap icon-lg rc-bar-screencap"
    [soti-tooltip]="'remoteControl_btn_ScreenShot' | xsI18n " placement="left"
    (click)="takeScreenshot()">
</div>
